import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dateInput", "presetSelect", "results", "flatpickrWrap"]
  static values = { url: String }

  connect() {
    this._boundDateChange = this._handleDateChange.bind(this)
    if (this.hasDateInputTarget) {
      this.dateInputTarget.addEventListener("change", this._boundDateChange)
    }
  }

  disconnect() {
    if (this.hasDateInputTarget && this._boundDateChange) {
      this.dateInputTarget.removeEventListener("change", this._boundDateChange)
    }
  }

  _handleDateChange() {
    const value = this.dateInputTarget.value
    if (value && value.includes(" to ")) {
      this._clearPreset()
      this._fetchResults(value)
    }
  }

  selectPreset() {
    const preset = this.presetSelectTarget.value
    if (!preset) return

    const [start, end] = this._presetToDates(preset)
    const rangeString = `${start} to ${end}`

    this._setFlatpickrDates(start, end)
    this.dateInputTarget.value = rangeString
    this._fetchResults(rangeString)
  }

  _presetToDates(preset) {
    const today = new Date()
    const dayOfWeek = today.getDay()
    let start, end

    switch (preset) {
      case "today":
        start = end = today
        break
      case "yesterday": {
        const yesterday = new Date(today)
        yesterday.setDate(today.getDate() - 1)
        start = end = yesterday
        break
      }
      case "this_week": {
        const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek
        start = new Date(today)
        start.setDate(today.getDate() + mondayOffset)
        end = today
        break
      }
      case "last_week": {
        const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek
        start = new Date(today)
        start.setDate(today.getDate() + mondayOffset - 7)
        end = new Date(start)
        end.setDate(start.getDate() + 6)
        break
      }
      case "this_month":
        start = new Date(today.getFullYear(), today.getMonth(), 1)
        end = today
        break
      case "last_month":
        start = new Date(today.getFullYear(), today.getMonth() - 1, 1)
        end = new Date(today.getFullYear(), today.getMonth(), 0)
        break
    }

    return [this._formatDate(start), this._formatDate(end)]
  }

  _formatDate(date) {
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, "0")
    const d = String(date.getDate()).padStart(2, "0")
    return `${y}-${m}-${d}`
  }

  _setFlatpickrDates(start, end) {
    if (!this.hasFlatpickrWrapTarget) return

    const fpController = this.application.getControllerForElementAndIdentifier(
      this.flatpickrWrapTarget,
      "flatpickr"
    )
    if (fpController?.fp) {
      fpController.fp.setDate([start, end], false)
    }
  }

  _clearPreset() {
    if (this.hasPresetSelectTarget) {
      this.presetSelectTarget.value = ""
    }
  }

  _fetchResults(dateRange) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("date", dateRange)

    this.resultsTarget.src = url.toString()
  }
}
